module.exports = __webpack_public_path__ + "static/media/appointment_notification.8c843675.mp3";